/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Faq_A6Inputs */

const en_formatter_faq_a6 = /** @type {(inputs: Formatter_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON numbers are read as double precision floats, which hold integers exactly only up to 2^53. A 20 digit ID gets rounded during parsing, before formatting even happens. Ask the API to send such IDs as JSON strings, which is the standard workaround.`)
};

const ko_formatter_faq_a6 = /** @type {(inputs: Formatter_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 숫자는 배정밀도 부동소수점으로 읽히며, 정수를 정확히 담는 한계는 2^53입니다. 20자리 ID는 포매팅이 시작되기도 전에 파싱 과정에서 반올림됩니다. 그런 ID는 JSON 문자열로 보내달라고 API에 요청하는 것이 표준적인 우회법입니다.`)
};

const ja_formatter_faq_a6 = /** @type {(inputs: Formatter_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON の数値は倍精度浮動小数点として読まれ、整数を正確に保持できるのは 2^53 までです。20 桁の ID は整形が始まる前、パースの段階で丸められます。そうした ID は JSON 文字列で送るよう API に依頼するのが標準的な回避策です。`)
};

/**
* | output |
* | --- |
* | "JSON numbers are read as double precision floats, which hold integers exactly only up to 2^53. A 20 digit ID gets rounded during parsing, before formatting e..." |
*
* @param {Formatter_Faq_A6Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_faq_a6 = /** @type {((inputs?: Formatter_Faq_A6Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Faq_A6Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_faq_a6(inputs)
	if (locale === "ko") return ko_formatter_faq_a6(inputs)
	return ja_formatter_faq_a6(inputs)
});